export default () => ({
  categories          : [],
  visibleCategories   : [],
  creatableCategories : []
});
